var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 15.6667C11.8413 15.6667 13.3337 14.1743 13.3337 12.3333C13.3337 10.4924 11.8413 9 10.0003 9C8.15938 9 6.66699 10.4924 6.66699 12.3333C6.66699 14.1743 8.15938 15.6667 10.0003 15.6667Z",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 12.4168L9.24186 12.9584C9.4002 13.1168 9.65853 13.1168 9.81686 12.9668L11.3002 11.6001",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.808 12.1667L18.0914 9.19167C18.308 7.15833 17.7247 5.5 14.1664 5.5H5.83303C2.27469 5.5 1.69136 7.15833 1.91636 9.19167L2.54136 15.8583C2.71636 17.4917 3.31636 18.8333 6.66636 18.8333H13.333C16.683 18.8333 17.283 17.4917 17.458 15.8583",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 5.49984V4.83317C6.66699 3.35817 6.66699 2.1665 9.33366 2.1665H10.667C13.3337 2.1665 13.3337 3.35817 13.3337 4.83317V5.49984",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0418 9.6665C16.6001 10.7165 15.0001 11.4498 13.3418 11.8665",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 9.8916C3.57526 10.8416 5.09193 11.5166 6.66693 11.8999",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_3163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationIcon);
export default __webpack_public_path__ + "static/media/designationIcon.07ad6d43ba43e07741848f1baccdc38a.svg";
export { ForwardRef as ReactComponent };